var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindowNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 22,
    viewBox: "0 0 66 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 22,
    fill: "#A098AE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2868_1153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.936 6.636L15.512 15H14.288L12.344 8.268L10.328 15L9.116 15.012L6.776 6.636H7.94L9.764 13.728L11.78 6.636H13.004L14.924 13.704L16.76 6.636H17.936ZM20.223 6.636V15H19.131V6.636H20.223ZM28.6602 15H27.5682L23.1762 8.34V15H22.0842V6.624H23.1762L27.5682 13.272V6.624H28.6602V15ZM33.1257 6.636C34.0377 6.636 34.8257 6.808 35.4897 7.152C36.1617 7.488 36.6737 7.972 37.0257 8.604C37.3857 9.236 37.5657 9.98 37.5657 10.836C37.5657 11.692 37.3857 12.436 37.0257 13.068C36.6737 13.692 36.1617 14.172 35.4897 14.508C34.8257 14.836 34.0377 15 33.1257 15H30.5217V6.636H33.1257ZM33.1257 14.1C34.2057 14.1 35.0297 13.816 35.5977 13.248C36.1657 12.672 36.4497 11.868 36.4497 10.836C36.4497 9.796 36.1617 8.984 35.5857 8.4C35.0177 7.816 34.1977 7.524 33.1257 7.524H31.6137V14.1H33.1257ZM42.798 15.084C42.022 15.084 41.314 14.904 40.674 14.544C40.034 14.176 39.526 13.668 39.15 13.02C38.782 12.364 38.598 11.628 38.598 10.812C38.598 9.996 38.782 9.264 39.15 8.616C39.526 7.96 40.034 7.452 40.674 7.092C41.314 6.724 42.022 6.54 42.798 6.54C43.582 6.54 44.294 6.724 44.934 7.092C45.574 7.452 46.078 7.956 46.446 8.604C46.814 9.252 46.998 9.988 46.998 10.812C46.998 11.636 46.814 12.372 46.446 13.02C46.078 13.668 45.574 14.176 44.934 14.544C44.294 14.904 43.582 15.084 42.798 15.084ZM42.798 14.136C43.382 14.136 43.906 14 44.37 13.728C44.842 13.456 45.21 13.068 45.474 12.564C45.746 12.06 45.882 11.476 45.882 10.812C45.882 10.14 45.746 9.556 45.474 9.06C45.21 8.556 44.846 8.168 44.382 7.896C43.918 7.624 43.39 7.488 42.798 7.488C42.206 7.488 41.678 7.624 41.214 7.896C40.75 8.168 40.382 8.556 40.11 9.06C39.846 9.556 39.714 10.14 39.714 10.812C39.714 11.476 39.846 12.06 40.11 12.564C40.382 13.068 40.75 13.456 41.214 13.728C41.686 14 42.214 14.136 42.798 14.136ZM58.9516 6.636L56.5276 15H55.3036L53.3596 8.268L51.3436 15L50.1316 15.012L47.7916 6.636H48.9556L50.7796 13.728L52.7956 6.636H54.0196L55.9396 13.704L57.7756 6.636H58.9516Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2868_1153",
    x: 2.776,
    y: 3.53906,
    width: 60.1757,
    height: 16.5449,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2868_1153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2868_1153",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowNew);
export default __webpack_public_path__ + "static/media/window_new.1de0c86151a4cf56cb5f515005a6b57d.svg";
export { ForwardRef as ReactComponent };